<template>
    <div class="v-icon mr-2 ">
        <v-dialog
            :value="viewPersonEmergencyContactDialog"
            max-width="700px"
            persistent
        >
            <v-card>
                <DialogTitle
                    :close="closeViewItem"
                    :dialog-name="dialogName"
                />
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex
                                md8
                                sm8
                                xs12
                            >
                                <v-text-field
                                    label="Name"
                                    readonly
                                    type="text"
                                    v-model="viewName"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm4
                                xs12
                            >
                                <v-text-field
                                    label="Relationship"
                                    readonly
                                    type="text"
                                    v-model="viewRelationship"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    label="Mobile"
                                    readonly
                                    type="text"
                                    v-model="viewMobilePhone"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    label="Telephone"
                                    readonly
                                    type="text"
                                    v-model="viewTelephone"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    label="Email"
                                    readonly
                                    type="text"
                                    v-model="viewEmailAddress"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    label="Address Line One"
                                    readonly
                                    type="text"
                                    v-model="viewAddressLineOne"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    label="Address Line Two"
                                    readonly
                                    type="text"
                                    v-model="viewAddressLineTwo"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    label="Town"
                                    readonly
                                    type="text"
                                    v-model="viewTown"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    label="County"
                                    readonly
                                    type="text"
                                    v-model="viewCounty"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-select
                                    :items="personnelCountryList"
                                    item-text="name"
                                    item-value="personnelCountryId"
                                    label="Country"
                                    readonly
                                    v-model="viewCountryId"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    label="Postcode"
                                    readonly
                                    type="text"
                                    v-model="viewPostCode"
                                />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <ViewDialogActions
                    :close="closeViewItem"
                />
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import EditTableFunctions from '../editTableFunctions';

    import {LOAD_PERSON_EMERGENCY_CONTACT_TO_VIEW, TOGGLE_VIEW_PERSON_EMERGENCY_CONTACT_DIALOG, UPDATE_EDIT_PERSON_EMERGENCY_CONTACT_FIELD} from "@/store/person_emergency_contact/mutations";
    import {FETCH_PERSON_EMERGENCY_CONTACT_LIST, SAVE_EDITED_PERSON_EMERGENCY_CONTACT} from "@/store/person_emergency_contact/actions.js";
    import {FETCH_PERSONNEL_COUNTRY_LIST} from "@/store/personnel_country/actions.js"
    import DialogTitle from "../../../../components/DialogTitle";
    import ViewDialogActions from "../../../../components/ViewDialogActions";

    export default {
        name: "ViewPersonEmergencyContactDialog",
        components: {
            DialogTitle,
            ViewDialogActions
        },

        mixins: [
            EditTableFunctions,
        ],


        props: {
            // item: {
            //     type: Object,
            //     required: true,
            // },
        },
        data() {
            return {
                // Required for editTableFunctions
                idName: 'feedbackId',
                dialogName: "View Emergency Contact"
            }
        },
        computed: {
            // viewPersonEmergencyContactDialog: {
            //     get() {
            //         return this.$store.state.person_employment.viewPersonEmergencyContactDialog;
            //     },
            // },
            viewName: {
                get() {
                    return this.$store.state.person_emergency_contact.viewPersonEmergencyContact.name;
                },
            },

            viewRelationship: {
                get() {
                    return this.$store.state.person_emergency_contact.viewPersonEmergencyContact.relationship;
                },
            },

            viewMobilePhone: {
                get() {
                    return this.$store.state.person_emergency_contact.viewPersonEmergencyContact.mobilePhone;
                },
            },

            viewTelephone: {
                get() {
                    return this.$store.state.person_emergency_contact.viewPersonEmergencyContact.telephone;
                },
            },

            viewEmailAddress: {
                get() {
                    return this.$store.state.person_emergency_contact.viewPersonEmergencyContact.emailAddress;
                },
            },

            viewAddressLineOne: {
                get() {
                    return this.$store.state.person_emergency_contact.viewPersonEmergencyContact.addressLineOne;
                },
            },

            viewAddressLineTwo: {
                get() {
                    return this.$store.state.person_emergency_contact.viewPersonEmergencyContact.addressLineTwo;
                },
            },

            viewTown: {
                get() {
                    return this.$store.state.person_emergency_contact.viewPersonEmergencyContact.town;
                },
            },

            viewCounty: {
                get() {
                    return this.$store.state.person_emergency_contact.viewPersonEmergencyContact.county;
                },
            },

            viewCountryId: {
                get() {
                    return this.$store.state.person_emergency_contact.viewPersonEmergencyContact.personnelCountryId;
                },
            },
            viewPostCode: {
                get() {
                    return this.$store.state.person_emergency_contact.viewPersonEmergencyContact.postCode;
                },
            },

            ...mapGetters(
            [
                "viewPersonEmergencyContactDialog",
                "personnelCountryList"
            ]
            ),
        },

        methods: {
            fetchCountryList() {
                this.$store.commit(FETCH_PERSONNEL_COUNTRY_LIST);
            },
            ...mapActions({
                fetchTableList: FETCH_PERSON_EMERGENCY_CONTACT_LIST,
                updateTableItemRecord: SAVE_EDITED_PERSON_EMERGENCY_CONTACT,
            }),

            ...mapMutations({
                toggleViewDialog: TOGGLE_VIEW_PERSON_EMERGENCY_CONTACT_DIALOG,
                loadTableItemToView: LOAD_PERSON_EMERGENCY_CONTACT_TO_VIEW,
                updateTableItemToEdit: UPDATE_EDIT_PERSON_EMERGENCY_CONTACT_FIELD,
            }),
        },
    }
</script>

<style scoped>
</style>
